import { Tabs, Tab, Box } from '@mui/material'
import { TabPanel } from 'entities/admin/ui/Participants/components/TabPanel/TabPanel'
import React from 'react';
import { createPaths } from "shared/lib/createPaths";
import {
    ADMIN_PANEL_PATH,
    MARATHONS_PATH,
    STEP1_CONTENT_PATH,
} from "pages/paths";
import ruImg from "../../../../../../assets/images/header/russianFlag.svg";
import enImg from "../../../../../../assets/images/header/britishFlag.svg";
import kgImg from "../../../../../../assets/images/header/kyrgyzFlag.svg";
import { useNavigate } from "react-router-dom";

interface LanguageTabPanelProps {
    value: number;
    errors: any;
    isEditMode?: boolean;
    setValue?: (value: number) => void;
    id: string | undefined;
}

export const LanguageTabPanel: React.FC<LanguageTabPanelProps> = ({ value, errors, isEditMode, setValue, id }) => {
    const navigate = useNavigate();

    const a11yProps = (index: any) => {
        return {
            id: `simple-tab-${index}`,
            "aria-controls": `simple-tabpanel-${index}`,
        };
    }

    const TabsHed = ({ img, name }: { name: string; img: string }) => {
        return (
            <Box sx={{ width: "100%", margin: 0, gap: "20px" }} className="tabshead">
                <img src={img} alt="" />
                {name}
            </Box>
        );
    }

    const getIndexError = (index: number) => {
        return (
            !!errors.dateEvent?.message ||
            !!errors?.translations?.[index] ||
            !!errors.publicOffer?.[index]
        );
    }

    const handleChange = (event: any, newValue: any) => {
        setValue?.(newValue);

        if (isEditMode) {
            const languageMap = ["ru", "en", "kg"];
            const targetLanguage = languageMap[newValue];
            const newPath = createPaths(
                ADMIN_PANEL_PATH,
                MARATHONS_PATH,
                id,
                STEP1_CONTENT_PATH,
                targetLanguage
            );
            navigate(newPath);
        } else {
            const languageMap = ["ru", "en", "kg"];
            const targetLanguage = languageMap[newValue];
            navigate(`/new/step-1?language=${targetLanguage}`);
        }
    };

    return (
        <>
            <Tabs value={value} onChange={handleChange}>
                <Tab
                    sx={{
                        background: getIndexError(1) ? "rgba(255,0,0,0.1)" : "",
                        border: "1px",
                        borderRadius: "7px",
                        marginRight: "5px",
                    }}
                    label={<TabsHed img={ruImg} name="Русский" />}
                    {...a11yProps(0)}
                />
                <Tab
                    sx={{
                        background: getIndexError(0) ? "rgba(255,0,0,0.1)" : "",
                        border: "1px",
                        borderRadius: "7px",
                        marginRight: "5px",
                    }}
                    label={<TabsHed img={enImg} name="English" />}
                    {...a11yProps(1)}
                />
                <Tab
                    sx={{
                        background: getIndexError(2) ? "rgba(255,0,0,0.1)" : "",
                        border: "1px",
                        borderRadius: "7px",
                        marginRight: "5px",
                    }}
                    label={<TabsHed img={kgImg} name="Кыргызча" />}
                    {...a11yProps(2)}
                />
            </Tabs>
        </>
    )
}

export default TabPanel